import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeTextBaseComponent } from './e5core-ui-work-field-type-text-base';

@Component({
  selector: 'e5core-ui-work-field-type-text-bootstrap',
  templateUrl: './e5core-ui-work-field-type-text-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-text-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeTextBootstrapComponent extends E5coreUiWorkFieldTypeTextBaseComponent {
}
